import GenericModal from '../../../Components/GenericModal'
import { useMutation, useQueryClient } from 'react-query'
import { AxiosResponse } from 'axios'
import { useParams } from 'react-router-dom'
import { usePhaseContext } from './PhaseAccordion'
import { useUserContext } from '../../../Contexts/UserConfig'
import PyAPI from '../../../APIs/Python/APIs/PyAPI'

function DeletePhaseModal({ open, setOpen }: { open: boolean; setOpen: any }) {
  const { whoAmI } = useUserContext()
  const { study_id } = useParams()
  const queryClient = useQueryClient()
  const phase = usePhaseContext()

  const {
    mutate: deletePhase,
    isLoading,
    error,
  } = useMutation<any, AxiosResponse>(
    () =>
      PyAPI.deleteCall(
        whoAmI,
        `/study/${study_id}/phase?phase_id=${phase.PhaseID}`,
      ),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: ['PyAPI', '/study'],
        })
      },
    },
  )

  return (
    <GenericModal
      open={open}
      loading={isLoading}
      error={error}
      setClose={() => {
        setOpen(false)
      }}
      setCommit={deletePhase}
      title={'Are you sure you wish to delete this phase?'}
      commitLabel={'Yes, delete'}
    />
  )
}

export default DeletePhaseModal
